import { TBoardId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import { boardSetDescription } from '../../../../../../../../../rest/effects/board/boardSetDescription';

export const onSave = (
    boardId: TBoardId,
    description: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
    ) => {
        dispatch(segmentTrackAction(SegmentBoardEvent.EDITED_DESCRIPTION));
        dispatch(boardSetDescription(boardId, description));
    };
    return action;
};
